<ng-container *ngIf="(!control.valid && control.touched) || (isShowAlways && preparedMessages.length)">
  <!-- <div class="small form-text text-error" *ngFor="let preparedMessage of preparedMessages">{{preparedMessage}}</div> -->
  <div [class]="'invalid-form-control ' + controlClass" *ngIf="!!preparedMessages.length" [innerHTML]="preparedMessages[0]"></div>
</ng-container>
<div *ngIf="isShowHelper" class="helper-form-control" [ngClass]="{ mb: helper }" [innerHTML]="helper | translate"></div>
